var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadButtonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2998,
    y: 0.662109,
    width: 29.4,
    height: 30,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2998,
    y: 0.662109,
    width: 29.4,
    height: 30,
    rx: 7.5,
    stroke: "#CBCBCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1998 8.26211H16.7998V17.3174V17.5309L16.9638 17.3942L19.8178 15.0159L20.9342 15.9463L15.9998 20.0583L11.0654 15.9463L12.1818 15.0159L15.0358 17.3942L15.1998 17.5309V17.3174V8.26211ZM23.0998 23.0621H8.8998V21.7621H23.0998V23.0621Z",
    fill: "#B4B1B1",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButtonIcon);
export default __webpack_public_path__ + "static/media/DownloadButtonIcon.1e5a32e592042634c960c1fad03b461a.svg";
export { ForwardRef as ReactComponent };